import { defineStore } from 'pinia';
import router from '../router';
import { initDB } from '../Database';

export const usewbuy_aiStore = defineStore('wbuy_aiStore', {
  state: () => ({
    loadQuery: false,
    socket: null,
    eventsRegistered: false, // Evita erros de referência
    rooms: {}, // Estrutura para armazenar salas
    processedMessageIds: new Set(), // Para rastrear mensagens já processadas
    credits: 0, // Armazenar os créditos do usuário
  }),

  actions: {
    
    createRoom(room) {
      this.rooms[room.id] = room;
    },

    clearMessagesRoom(roomId) {

      if (this.rooms[roomId]) {
        this.rooms[roomId].messages = [];
      }

    },

    
    getMessagesRoom(roomId) {
      if (this.rooms[roomId]) {
        return this.rooms[roomId].messages;
      } 
      return [];
    },

    // Método para atualizar os créditos
    updateCredits(amount) {
      // Certifica-se que estamos lidando com números
      this.credits = typeof amount === 'number' ? amount : parseFloat(amount) || 0;
    },
    
    // Método para obter os créditos
    getCredits() {
      return this.credits;
    },
    
    async initializeListeners(socket) {
      // Se já tiver registrado eventos e o socket for o mesmo, não registre novamente
      if (this.eventsRegistered && this.socket === socket) return;
      
      // Se já havia eventos registrados em outro socket, desregistre-os
      if (this.socket) {
        this.socket.off('presence:start');
        this.socket.off('chat:received:message');
        this.socket.off('chat:typing');
      }

      await initDB(); // Inicializa o banco de dados

      // Listener: presença de usuários
      socket.on('presence:start', async (data) => {
        // Status inicial de presença com os créditos
        console.log('[Socket] presence:start', data);
        if (data && data.status === 'connected') {
          if (data.credits !== undefined) {
            this.updateCredits(data.credits);
            console.log('[Socket] Credits updated:', this.credits);
          }
        }
      });

      // Listener: Recebimento de mensagem
      socket.on('chat:received:message', async (data) => {
        try {
          data = JSON.parse(data);
          
          // Gera um ID único para a mensagem
          const messageId = data.id || `${data.message}-${data.timestamp}-${data.role}-${data.room_id}`;
          
          // Verifica se a mensagem já foi processada
          if (this.processedMessageIds.has(messageId)) {
            console.log('Mensagem duplicada ignorada:', messageId);
            return;
          }
          
          // Marca mensagem como processada
          this.processedMessageIds.add(messageId);
          
          // Cria a sala caso não exista
          if (!this.rooms[data.room_id]) {
            this.createRoom({ id: data.room_id, messages: [] });
          }
          
          // Adiciona mensagem na sala
          this.rooms[data.room_id].messages.push(data);
        } catch (error) {
          console.error('Erro ao processar mensagem recebida:', error);
        }
      });

      // Listener: Aviso de digitação
      socket.on('chat:typing', async (data) => {
        console.log('chat:typing', data);
      });

      // Marca os eventos como registrados e armazena a instância do socket
      this.eventsRegistered = true;
      this.socket = socket;
      
      //console.log('Socket listeners initialized');
    },

    // Método para limpar o registro de mensagens processadas (útil em casos específicos)
    clearProcessedMessageIds() {
      this.processedMessageIds.clear();
    },
    
    uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    },
  },
});
